export default {
  en: {
    translation: {
      login: {
        password: 'Password',
        signIn: 'Sign In',
        username: 'Username'
      },
      reset: {
        email: 'Email',
        emailMessage: 'Please enter your email address below and we will send you a reset link.',
        emailMessageError: 'Email address can not be found. Please contact customer support for assistance.',
        submitRequest: 'Submit Request',
        title: 'Here are the requirements for your new password. Make sure that your password:',
        emailSent: "If the address exists in our system, we will send the reset email to that address. If you can't find the message in your inbox, check your spam folder.",
        minlength: 'is longer than 8 characters.',
        case: 'contains upper & lower case letters',
        number: 'contains at least one number.',
        resetPassword: 'Reset Password',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        returnApplication: 'Return to Application'
      },
      change: {
        oldPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm New Password',
        changePassword: 'Change Password',
        success: 'Password changed successfully. Click the link below to return to the application.'
      },
      error: {
        unknown: 'An unknown error occurred. Please contact support.',
        internalError: 'An internal error has occurred. Please contact support for assistance.',
        networkError: 'An internal error has occurred. Please contact support for assistance.',
        invalidCredentials: 'Invalid Username or Password',
        NOT_COMPLEX: 'Password does not fulfill complexity requirements',
        SAME_AS_RECENT: 'Password was used recently. Please choose another password.',
        EXPIRED_HASH: 'Link to reset password is expired. Please request a new link or contact Technical support for assistance.',
        INACTIVE_ACCOUNT: 'Account is currently disabled. Please contact Technical support to re-enable your account.',
        '404': '404 - Page not found',
        '404Message': 'The page you are looking for is not found',
        '404Description': "The page you are looking for does not exist. It may have been moved, or removed altogether. Perhaps you can return back to the site’s homepage and see if you can find what you are looking for."
      }
    }
  }
}